import Subscription from "seneca-common/features/subscriptions/state/models/subscriptions/subscription/Subscription";

export default function findSubscriptionToShow(
  conditions: ((sub: Subscription) => boolean)[],
  subscriptions: Subscription[]
) {
  for (const key in conditions) {
    const condition = conditions[key];
    const subscription = subscriptions.find(condition);
    if (subscription) return subscription;
  }
}
